module.exports = __webpack_public_path__ + "static/contrary-logo-f97c8b053b6fb81bbce938cb8cb36999.png";